import { GetServerSideProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { FC } from "react";
import HorizontalCard from "~/components/Card/HorizontalCard";
import { Container } from "~/components/Container";
import Experience from "~/components/HomeSections/Experience";
import Hero from "~/components/ResourceSections/Hero";
import Api from "~/services/api";
import { Resource } from "~/services/resource";
import styles from "~/styles/pages/Releases.module.scss";
import Trans from "~/types/translationKeys";

export const getServerSideProps: GetServerSideProps = async ({
  params: _params,
  query: { page },
  locale,
}) => {
  const params = {
    page: page ? Number(page) : 1,
    page_size: 10,
    populate: "thumbnail",
    sort: "createdAt:DESC",
  };

  let releases: Resource[] | undefined = [];

  const res = await Api<{ data: any }>({
    url: "/v1/resources/releases",
    method: "GET",
    params,
  });

  releases = res.data;

  return {
    props: {
      releases,
      res,
      ...(await serverSideTranslations(locale || "en", ["common"])),
    },
  };
};

const Releases: FC = (props: Record<string, any>) => {
  const router = useRouter();
  const releases = props.releases;
  const pagination = props?.res?.meta?.pagination;
  const { t } = useTranslation();

  return (
    <div>
      <Hero title={t(Trans.releases)} />
      <Container>
        <section className={styles.releases}>
          <div className={styles.releases_wrapper}>
            {releases?.map((item: Resource) => (
              <HorizontalCard
                key={item.id}
                {...item}
                url={`/resources/releases/${item.slug}`}
                thumbnail={item?.thumbnail?.url}
                date={item.createdAt}
              />
            ))}
          </div>
        </section>
        {/* <div className="flex justify-center">
          <Pagination
            total={pagination?.total}
            pageSize={pagination?.pageSize}
            value={pagination?.page}
            className={styles.pagination}
            onChange={(value) => {
              router.push({
                pathname: router.pathname,
                query: {
                  page: value,
                },
              });
            }}
          />
        </div> */}
      </Container>
      <Experience />
    </div>
  );
};

export default Releases;
